<template>
  <AdminShell
    :page-title="pageTitle"
    :page-subtitle="pageSubtitle"
    active-menu="reply"
  >
  <div class="bigscreen">
    <el-card class="room-toolbar" shadow="never">
      <el-form inline size="small" class="room-toolbar-form">
        <el-form-item label="直播间">
          <el-select
            v-model="selectedRoomKey"
            class="room-select"
            filterable
            placeholder="请选择直播间"
            :loading="roomsLoading"
            :disabled="goodsRemoving"
            @change="handleRoomChange"
          >
            <el-option
              v-for="room in filteredRooms"
              :key="roomOptionValue(room)"
              :label="formatRoomOptionLabel(room)"
              :value="roomOptionValue(room)"
            >
              <div class="room-option">
                <span class="room-option-name">{{ roomDisplayName(room) }}</span>
                <span class="room-option-meta">{{ formatRoomStart(room) }} · {{ roomStatusText(room) }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开播时间">
          <el-date-picker
            v-model="roomTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="handleRoomTimeFilterChange"
          />
        </el-form-item>
        <el-form-item>
          <el-button @click="clearRoomTimeFilter">清空筛选</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row :gutter="16" class="full">
      <el-col class="left">
        <el-card class="panel video-panel" shadow="always">
          <div slot="header" class="panel-title">直播 / 回放</div>
          <div class="video-wrap" :class="{ 'is-history': !isSelectedRoomLive }">
            <div ref="agoraContainer" class="agora-container">
              <!-- Agora 远端视频会渲染在这里 -->
            </div>
            <button
              class="video-toggle-btn"
              type="button"
              :disabled="!isSelectedRoomLive || !activeRemoteUid"
              @click.stop="toggleVideoPlayback"
            >
              <i :class="videoPaused ? 'el-icon-video-play' : 'el-icon-video-pause'"></i>
              <span>{{ videoPaused ? '恢复' : '暂停' }}</span>
            </button>
            <div v-if="isSelectedRoomLive && videoPaused" class="video-paused-mask">
              已暂停
            </div>
            <div v-if="!isSelectedRoomLive" class="agora-placeholder history-placeholder">
              历史直播，预览不可用
            </div>
            <div v-else-if="previewLoading" class="agora-placeholder preview-loading">
              <i class="el-icon-loading"></i>
              <span>正在连接直播预览...</span>
            </div>
            <div v-else-if="!remoteJoined" class="agora-placeholder">
              等待主播开播...
            </div>
          </div>
          <video ref="snapshotVideo" muted playsinline
            style="position:fixed;left:-9999px;top:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;"></video>
        </el-card>

      </el-col>
      <el-col class="middle">
        <el-card class="panel danmaku-panel" shadow="always">
          <div slot="header" class="panel-title">弹幕</div>
          <div v-if="roomId" class="danmaku-wrap">
            <Danmaku ref="danmu" :key="danmakuKey" :url="danmakuUrl" :room-id="danmu_roomId" :token="token" :watcher="true"
              :readonly-history="!isSelectedRoomLive" :soundEnabled="isSelectedRoomLive">
              <span v-if="isSelectedRoomLive" class="icon" @click="changeFB">
                <img src="../assets/facebook.png" style="width: 35px; height: 35px" />
              </span>
              <span v-if="isSelectedRoomLive" class="icon" @click="changeWa">
                <img src="../assets/whatsapp.png" style="width: 35px; height: 35px" />
              </span>
            </Danmaku>
          </div>
          <div v-else class="danmaku-empty">请选择房间以加载弹幕</div>
        </el-card>
      </el-col>
      <el-col class="right">
        <el-row>
          <el-tabs v-model="rightActiveTab" type="border-card" class="right-tabs">
            <el-tab-pane label="商品管理" name="goods">
              <live-goods-manager ref="goodsManager" :items="goods" :loading="goodsLoading" :removing="goodsRemoving" :removal-progress="goodsRemovalProgress" :selection-key="selectedRoomKey" :disabled="!isSelectedRoomLive || goodsSaving || goodsLoading || goodsRemoving" :disabled-message="!isSelectedRoomLive ? '历史直播商品列表只读，编辑操作已禁用' : goodsRemoving ? `正在移除商品 ${goodsRemovalProgress.current}/${goodsRemovalProgress.total}…` : goodsSaving ? '正在保存商品顺序…' : '正在加载商品列表…'" @reorder="handleReorder" @add="handleAdd" @refresh="fetchGoods"
                @search="handleSearch" @toggle-offline="handleToggleOnline" @show-data="openStats"
                @explain="startExplain" @select-change="handleSelectChange" @batch-remove="handleBatchRemove" :get-live-source-el="getLiveSourceEl" />
            </el-tab-pane>
            <!-- <el-tab-pane label="模拟发送" name="warmup">

             <div class="warmup-wrap">
                <el-alert title="用于直播暖场：定时随机选择一个『小号』和『话术』发送到弹幕。" type="info" show-icon :closable="false"
                  class="warmup-tip" />
                <el-form label-width="90px" size="mini">
                  <el-form-item label="用户弹WA">
                    <el-switch v-model="open_contact" active-text="开启" inactive-text="关闭" @change="send_user_wa" />
                  </el-form-item>
                  <el-form-item label="发送开关">
                    <el-switch v-model="warmup.enabled" active-text="开启" inactive-text="关闭"
                      @change="handleWarmupToggle" />
                    <span class="warmup-status" :class="{ on: warmup.running }">
                      {{ warmup.running ? '运行中' : '未运行' }}
                    </span>
                  </el-form-item>

                  <el-form-item label="发送间隔">
                    <el-input-number v-model="warmup.intervalSecMin" :min="1" :max="600" controls-position="right" /> 秒
                    <span style="margin:0 6px;">~</span>
                    <el-input-number v-model="warmup.intervalSecMax" :min="1" :max="600" controls-position="right" /> 秒
                    <span class="warmup-hint">（每次发送会在区间内随机）</span>
                  </el-form-item>

                  <el-form-item label="小号列表">
                    <el-input type="textarea" :rows="4" placeholder="每行一个昵称，例如：小助理 / 客服管理 / A / 157****963"
                      v-model="warmup.accountsText" />
                    <div class="warmup-hint">支持粘贴多行；空行会自动忽略。</div>
                  </el-form-item>

                  <el-form-item label="话术库">
                    <el-input type="textarea" :rows="6" placeholder="每行一条话术，例如：主播好好看 / 这款真的很适合我 / 刚刚那个链接发一下"
                      v-model="warmup.messagesText" />
                    <div class="warmup-hint">支持粘贴多行；空行会自动忽略。</div>
                  </el-form-item>

                  <el-form-item label="发送预览">
                    <div class="preview-line">
                      <el-tag size="mini" type="success">{{ warmup.previewAccount || '（小号）' }}</el-tag>
                      <span class="preview-sep">：</span>
                      <span class="preview-msg">{{ warmup.previewMessage || '（话术）' }}</span>
                      <el-button size="mini" style="margin-left:10px;" @click="refreshWarmupPreview">换一组</el-button>
                    </div>
                  </el-form-item>

                  <el-form-item>
                    <el-button type="primary" size="mini" :disabled="!canWarmupSend"
                      @click="sendWarmupOnce">立即发送一条</el-button>
                    <el-button size="mini" :disabled="!warmup.running" @click="stopWarmup">停止</el-button>
                  </el-form-item>

                  <el-form-item label="事件类型">
                    <el-input v-model="warmup.eventType"
                      placeholder="默认：LIVE_ROOM_STREAM_EVENT_TYPE_ADMIN_SENT_CUSTOMER_CHAT" />
                    <div class="warmup-hint">
                      如果你们后端事件类型不同，可以在这里改；发送 payload: { nickname, content }。
                    </div>
                  </el-form-item>
                </el-form>
              </div>

            </el-tab-pane> -->

            <el-tab-pane label="暖场任务" name="task">
              <warmupTask :roomId="danmu_roomId"></warmupTask>
            </el-tab-pane>
            <el-tab-pane label="发红包" name="redpacket">
              <RedPacketPane :room-id="danmu_roomId" :appid="1" />
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog title="修改客服账号" :visible.sync="changeCustomerDialog">
      <el-form>
        <el-form-item :label="'新客服账号(' + wa_or_fb + ')'">
          <el-input v-model="customerNumber" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div>tips: messager账号填主页名称,例如 HKsistershop</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeCustomerDialog = false">取 消</el-button>
        <el-button type="primary" @click="changeCustomerDialog = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
  </AdminShell>
</template>
<script>
import AdminShell from '@/components/admin/AdminShell.vue'
import Danmaku from '@/components/Danmaku.vue'
import warmupTask from '@/components/warmupTask.vue'
import LiveGoodsManager from '@/components/LiveGoodsManager.vue'
import RedPacketPane from '@/components/RedPacketPane.vue'

import { liveroomsList, getProductList, reorderProducts, deleteProduct ,getAppid } from '@/api'
import { getToken } from '@/utils/auth'
import { requestAgoraRtcToken } from '@/utils/agora-token'
import AgoraRTC from 'agora-rtc-sdk-ng'
const DEFAULT_STATS_BASE = (process.env.VUE_APP_STREAMER_STATS_BASE || 'https://streamer.wokfoy.com').replace(',', '.')
const DANMAKU_WS = 'wss://danmuadmin.wokfoy.com:9981/b'
const DEFAULT_POSTER = 'https://via.placeholder.com/640x360/0d1a2f/0f9dff?text=Live+Preview'
const AUDIENCE_ROLE = 'audience'
const RTC_TOKEN_ENDPOINT = process.env.NODE_ENV === 'production'
  ? 'https://anal.wokfoy.com/api/v1/rtc/token'
  : '/api/v1/rtc/token'
const RTC_AUDIENCE_TOKEN_ROLE = 'subscriber'
const GOODS_LOADING_FALLBACK_MS = 8000
const warmupMessage = import('../assets/warmup_messages_en.json')
export default {
  name: 'LiveReplyPage',
  components: { AdminShell, Danmaku, LiveGoodsManager, warmupTask,RedPacketPane },
  data() {
    return {
      pageTitle: '\u76f4\u64ad\u56de\u590d',
      pageSubtitle: '\u5728\u76f4\u64ad\u8fc7\u7a0b\u4e2d\u67e5\u770b\u5f39\u5e55\u3001\u5546\u54c1\u4e0e\u6696\u573a\u4efb\u52a1\u3002',
      loading: false,
      error: '',
      apiBase: DEFAULT_STATS_BASE,
      videoSrc: '',
      poster: DEFAULT_POSTER,
      hls: null,
      roomId: '',
      danmu_roomId: '',
      danmakuUrl: DANMAKU_WS,
      allRooms: [],
      roomsLoading: false,
      goodsLoading: false,
      goodsSaving: false,
      goodsRemoving: false,
      goodsRemovalProgress: { current: 0, total: 0 },
      selectedGoodsIds: [],
      previewLoading: false,
      selectedRoomKey: '',
      currentRoom: null,
      roomTimeRange: [],
      warmupClientReady: false,

      // 后台观察页仅以观众身份进入直播间，不创建或发布本地音视频轨道。
      agoraClient: null,
      remoteJoined: false,
      activeRemoteUid: '',
      videoPaused: false,
      agora: {
        appId: '656131426d3845acadd7c7e18bf2e19a',
        token: null, // TODO: 从后台获取或在此处填入观众 token（如果开启了鉴权）
        uid: null,
        uidMode: '',
        sessionId: ''
      },
      loadingToken: false,
      tokenServer: RTC_TOKEN_ENDPOINT,
      open_contact: false,

      // 右侧选项卡：商品管理 / 模拟用户发言
      rightActiveTab: 'goods',

      warmup: {
        enabled: false,
        running: false,
        timer: null,
        intervalSecMin: 3,
        intervalSecMax: 8,
        accountsText: 'gu_***115\ngu_***151\ngu_***363',
        messagesText: 'Welcome everyone! 👋\nHi fam, I’m here!\nJust joined—what did I miss?\nLet’s goooo 🔥\nThis stream is vibing already 😍\nSay hi in the chat everyone!\nWhere are you watching from?\nDrop a “1” if you can hear us clearly!\nDrop a “🔥” if you’re ready!\nWho else is new here?\nFirst time here but I love the energy!\nThis is my favorite live room!\nThe host is so fun 😂\nI’m staying till the end!\nLet’s support the host guys 🙌\nI’m sharing this to my friends!\nHost is looking amazing today!\nThe host is so sweet ❤️\nYou explain things so clearly!\nYour energy is everything!\nI love your vibe 😭💖\nThis is the best live I’ve watched today!\nYou’re so professional!\nThe way you show details is perfect!\nI trust your recommendations!\nHost never disappoints 🔥\nThis looks so good!\nWait… this is actually nice.\nIs this the new one?\nCan you show it closer please?\nHow’s the quality on this?\nDoes it come in other colors?\nWhat size are you wearing?\nCan you try it on?\nI’m adding this to my cart 😭\nThis is a must-have!\nChat, this is so worth it.\nI need this ASAP.\nThis is giving premium vibes.\nThe details are insane!\nI love the texture!\nLooks expensive 👀\nThis deal is crazy!\nThat price is actually wild…\nDon’t wait guys, it’ll sell out.\nI bought it before it’s gone!\nI’m checking out now ✅\nIf you’re thinking about it, just grab it.\nThis is a steal!\nThis is the lowest I’ve seen.\nLimited stock, hurry!\nI regret not buying last time—getting it now.\nIf you miss this you’ll regret it.\nOk I’m ordering this right now.\nI’m grabbing two.\nOne for me and one for my sister.\nI bought this last week and I LOVE it.\nI have this already—quality is great.\nI got it in black, so good!\nThis one is super comfy.\nIt looks even better in person.\nHonestly worth every penny.\nIt’s been holding up really well.\nI got so many compliments wearing this.\nThis is my daily go-to.\nI ordered it again for my mom.\nI’ve been waiting for this restock!\nFinally it’s back!\nDoes it ship to the US?\nHow long does shipping take?\nIs there free shipping?\nAny discount codes?\nCan I pay with PayPal?\nIs there a warranty?\nWhat’s the return policy?\nDo you have size chart?\nIs it true to size?\nWill it restock if sold out?\nSo cute!\nNeed it!\nObsessed 😍\nInstant buy.\nAdded to cart ✅\nWorth it.\nSo clean.\nLooks premium.\nPerfect gift.\nI’m sold.\nTake my money 😂\nThis is it!\nChat, are we getting this?\nType “YES” if you want it!\nWho already got one?\nLet’s hit 1k likes!\nEveryone tap the screen!\nSpam the hearts ❤️❤️❤️\nDrop your size in chat!\nSay “ME” if you want a coupon!\nIf you’re here, don’t be shy—say hi!\nLet’s go team!\nHey everyone!\nJust joined—looks fun in here.\nThis item is actually pretty nice.\nHost is explaining it so well.\nI’m thinking about getting this.\nChat, the price is good right now.\nOk I’m adding to cart.\nDon’t miss it guys!\nThis stream is so chill.\nI’m staying for the next one too.',
        previewAccount: '',
        previewMessage: '',
        // 默认事件类型（如后端不同可改）
        eventType: 'LIVE_ROOM_STREAM_EVENT_TYPE_USER_SEND_MESSAGE',
      }, goods: [],
      _snapshotMst: null,
      _warmupReadyTimer: null,
      _roomSelectSeq: 0,
      _goodsRequestSeq: 0,
      _goodsLoadingFallbackTimer: null,

      changeCustomerDialog: false,
      wa_or_fb: 'WA',
      customerNumber: '',

      warmupInnerTab: 'task',
      wokfoy_appid:''
    }
  },
  async mounted() {
    try {
      let { data: apps } = await getAppid()
      const appList = Array.isArray(apps) ? apps : (Array.isArray(apps?.data) ? apps.data : [])
      const firstApp = appList[0]
      if (!firstApp?.id) {
        throw new Error('commercial appid missing')
      }
      this.wokfoy_appid = firstApp.id
      await this.loadRooms()
    } catch (err) {
      console.error('[LiveReply] init failed', err)
      this.$message && this.$message.error('直播回复页初始化失败，请刷新重试')
    }
  },
  beforeDestroy() {
    this.stopWarmup()
    this.clearWarmupReadyTimer()
    this.clearGoodsLoadingFallbackTimer()
    this.leaveAgoraChannel()
    if (this._snapshotMst) {
      this._snapshotMst?.stop()
      this._snapshotMst = null
    }
  },
  computed: {
    token() {
      return this.$store.getters.token || localStorage.getItem('lvtu_live_apitoken') || getToken()
    },
    activeRoomId() {
      return this.roomId || ''
    },
    filteredRooms() {
      const list = Array.isArray(this.allRooms) ? this.allRooms : []
      if (!Array.isArray(this.roomTimeRange) || this.roomTimeRange.length !== 2 || !this.roomTimeRange[0] || !this.roomTimeRange[1]) {
        return list
      }
      const start = this.parseTimestamp(this.roomTimeRange[0])
      const end = this.parseTimestamp(this.roomTimeRange[1])
      if (start == null || end == null) return list
      return list.filter(room => {
        const ts = this.parseRoomStartTimestamp(room)
        return ts != null && ts >= start && ts <= end
      })
    },
    selectedRoom() {
      return this.currentRoom || this.allRooms.find(room => this.roomOptionValue(room) === this.selectedRoomKey) || null
    },
    isSelectedRoomLive() {
      return Number(this.selectedRoom?.status) === 1
    },
    danmakuKey() {
      return `${this.danmu_roomId || 'empty'}-${this.isSelectedRoomLive ? 'live' : 'history'}`
    },
    canWarmupSend() {
      return this.isSelectedRoomLive && !!this.danmu_roomId && this.getWarmupAccounts().length > 0 && this.getWarmupMessages().length > 0 && this.warmupClientReady
    }
  },
  watch: {
    videoSrc() {
      this.$nextTick(this.setupVideo)
    },
  },
  methods: {
    getLiveSourceEl() {
      return this.$refs.snapshotVideo || null
    },
    getSixMonthsAgoStart() {
      const date = new Date()
      date.setMonth(date.getMonth() - 6)
      return this.formatDateTime(date)
    },
    normalizeRoomsResponse(res) {
      if (Array.isArray(res)) return res
      if (Array.isArray(res?.data)) return res.data
      if (Array.isArray(res?.data?.data)) return res.data.data
      if (Array.isArray(res?.list)) return res.list
      return []
    },
    roomOptionValue(room) {
      if (!room) return ''
      return String(room.id || room.stream_name || room.room_id || '')
    },
    roomDisplayName(room) {
      if (!room) return '-'
      return room.live_title || room.title || room.name || room.room_name || room.stream_name || room.id || '-'
    },
    getRoomStartValue(room) {
      if (!room) return ''
      return room.time_on || room.start_time || room.created_at || room.created_time || ''
    },
    parseTimestamp(value) {
      if (value == null || value === '') return null
      if (value instanceof Date) {
        const ts = value.getTime()
        return Number.isNaN(ts) ? null : ts
      }
      if (typeof value === 'number') {
        if (!Number.isFinite(value)) return null
        return value < 1000000000000 ? value * 1000 : value
      }
      const text = String(value).trim()
      if (!text) return null
      if (/^\d+$/.test(text)) {
        const num = Number(text)
        return num < 1000000000000 ? num * 1000 : num
      }
      const parsed = Date.parse(text.replace(/-/g, '/'))
      return Number.isNaN(parsed) ? null : parsed
    },
    parseRoomStartTimestamp(room) {
      return this.parseTimestamp(this.getRoomStartValue(room))
    },
    formatRoomStart(room) {
      const ts = this.parseRoomStartTimestamp(room)
      if (ts == null) return '开播时间未知'
      return this.formatDateTime(new Date(ts))
    },
    roomStatusText(room) {
      const status = Number(room?.status)
      if (status === 1) return '直播中'
      if (status === 0) return '未开播'
      if (status === 2) return '已结束'
      return `状态 ${room?.status ?? '-'}`
    },
    formatRoomOptionLabel(room) {
      return `${this.roomDisplayName(room)} / ${this.formatRoomStart(room)} / ${this.roomStatusText(room)}`
    },
    clearWarmupReadyTimer() {
      if (this._warmupReadyTimer) {
        clearInterval(this._warmupReadyTimer)
        this._warmupReadyTimer = null
      }
    },
    clearGoodsLoadingFallbackTimer() {
      if (this.$data._goodsLoadingFallbackTimer) {
        clearTimeout(this.$data._goodsLoadingFallbackTimer)
        this.$data._goodsLoadingFallbackTimer = null
      }
    },
    watchWarmupClientReady() {
      this.clearWarmupReadyTimer()
      this.warmupClientReady = false
      if (!this.isSelectedRoomLive) return
      this._warmupReadyTimer = setInterval(() => {
        const ok = !!this.$refs.danmu?.client
        if (ok) {
          this.warmupClientReady = true
          this.clearWarmupReadyTimer()
        }
      }, 300)
    },
    async loadRooms() {
      this.roomsLoading = true
      try {
        const { data: res } = await liveroomsList(this.wokfoy_appid, 100, 1, this.getSixMonthsAgoStart())
        const rooms = this.normalizeRoomsResponse(res)
        this.allRooms = rooms
        const active = rooms.find(item => Number(item.status) === 1) || rooms[0] || null
        await this.selectRoom(active)
      } catch (err) {
        console.error('[LiveReply] loadRooms failed', err)
      } finally {
        this.roomsLoading = false
      }
    },
    async handleRoomChange(value) {
      const room = this.allRooms.find(item => this.roomOptionValue(item) === value) || null
      await this.selectRoom(room)
    },
    async handleRoomTimeFilterChange() {
      const exists = this.filteredRooms.some(room => this.roomOptionValue(room) === this.selectedRoomKey)
      if (!exists) {
        await this.selectRoom(this.filteredRooms[0] || null)
      }
    },
    async clearRoomTimeFilter() {
      this.roomTimeRange = []
      if (!this.selectedRoomKey && this.filteredRooms.length) {
        await this.selectRoom(this.filteredRooms[0])
      }
    },
    async selectRoom(room) {
      const roomSelectSeq = ++this.$data._roomSelectSeq
      this.stopWarmup()
      this.clearWarmupReadyTimer()
      this.warmupClientReady = false
      this.currentRoom = room || null
      this.selectedRoomKey = this.roomOptionValue(room)
      this.roomId = room?.stream_name || ''
      this.danmu_roomId = room?.id || ''
      this.$store.commit('SET_CURRENT_ROOM', this.danmu_roomId || '')

      if (!room) {
        this.goods = []
        this.goodsLoading = false
        this.clearGoodsLoadingFallbackTimer()
        this.previewLoading = false
        this.videoSrc = ''
        this.leaveAgoraChannel().catch(err => {
          console.error('[LiveReply] leave channel after clear room failed', err)
        })
        return
      }

      if (Number(room.status) === 1) {
        this.updateVideoSource(room.stream_name)
        this.$nextTick(this.watchWarmupClientReady)
      } else {
        this.videoSrc = ''
        this.previewLoading = false
        this.leaveAgoraChannel().catch(err => {
          console.error('[LiveReply] leave channel after history room selected failed', err)
        })
      }
      this.fetchGoods(roomSelectSeq, { showLoading: Number(room.status) === 1 })
    },
    updateVideoSource(room) {
      if (!room) {
        this.videoSrc = ''
        return
      }
      if (!this.isSelectedRoomLive) {
        this.videoSrc = ''
        return
      }
      const trimmed = String(room).trim()
      this.videoSrc = trimmed || ''
    },
    formatNumber(value) {
      return Number(value || 0).toLocaleString()
    },
    formatDateTime(date) {
      const pad = n => String(n).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
    formatTime(value) {
      const ts = this.parseTimestamp(value)
      if (ts == null) return '-'
      const d = new Date(ts)
      const pad = n => String(n).padStart(2, '0')
      return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    buildQueryParams({ limit = 500, offset = 0 } = {}) {
      const params = new URLSearchParams()
      params.set('limit', limit)
      params.set('offset', offset)
      const filters = this.filters || {}
      if (Array.isArray(filters.range) && filters.range.length === 2) {
        const [start, end] = filters.range
        if (start) params.set('from', start)
        if (end) params.set('to', end)
      }
      if (filters.room) params.set('room_id', filters.room)
      if (filters.source) params.set('source', filters.source)
      return params.toString()
    },
    async setupVideo() {
      // 对接 Agora 播放器：当 videoSrc（房间名）变化时，作为观众加入对应频道
      if (!this.videoSrc || !this.isSelectedRoomLive) {
        await this.leaveAgoraChannel()
        return
      }
      await this.joinAudienceChannel(this.videoSrc)
    },

    async initAudienceClient() {
      if (this.agoraClient) return
      if (!this.agora.appId) {
        console.warn('[LiveReply] 请先在环境变量中配置 VUE_APP_AGORA_APPID')
        return
      }
      const client = AgoraRTC.createClient({ mode: 'live', codec: 'h264' })
      client.setClientRole(AUDIENCE_ROLE)

      client.on('user-published', this.handleUserPublished)
      client.on('user-unpublished', this.handleUserUnpublished)
      client.on('token-privilege-will-expire', () => {
        this.renewAudienceToken().catch(err => {
          console.error('[LiveReply] renew token before expire failed', err)
        })
      })
      client.on('token-privilege-did-expire', () => {
        this.renewAudienceToken().catch(err => {
          console.error('[LiveReply] renew token after expire failed', err)
        })
      })

      this.agoraClient = client
      console.log(client)
    },
    getRtcSessionKey(channel, role = RTC_AUDIENCE_TOKEN_ROLE) {
      const channelName = String(channel || '').trim()
      return `rtc:v1:session:live-reply:${channelName}:${role}`
    },
    getStoredRtcSessionId(channel, role = RTC_AUDIENCE_TOKEN_ROLE) {
      try {
        return sessionStorage.getItem(this.getRtcSessionKey(channel, role)) || ''
      } catch (error) {
        return ''
      }
    },
    saveRtcSessionId(channel, sessionId, role = RTC_AUDIENCE_TOKEN_ROLE) {
      const value = String(sessionId || '').trim()
      if (!value) return
      try {
        sessionStorage.setItem(this.getRtcSessionKey(channel, role), value)
      } catch (error) {
        // ignore storage failures
      }
    },
    async fetchAudienceToken(channel) {
      if (!this.tokenServer) {
        alert('未配置 Token 服务：请在 tokenServer 中填入你的服务地址或设置 VUE_APP_TOKEN_SERVER');
        throw new Error('token server missing');
      }
      this.loadingToken = true;
      try {
        const sessionId = this.getStoredRtcSessionId(channel)
        const tokenData = await requestAgoraRtcToken({
          tokenServer: this.tokenServer,
          channel,
          role: RTC_AUDIENCE_TOKEN_ROLE,
          uidMode: 'uid',
          sessionId,
        })
        if (tokenData.sessionId) {
          this.saveRtcSessionId(channel, tokenData.sessionId)
        }
        this.$set(this.agora, 'token', tokenData.token)
        this.$set(this.agora, 'appId', tokenData.appId)
        this.$set(this.agora, 'uid', tokenData.uid)
        this.$set(this.agora, 'uidMode', tokenData.uidMode || '')
        this.$set(this.agora, 'sessionId', tokenData.sessionId || sessionId || '')
        return tokenData
      } catch (e) {
        console.error(e);
        alert('获取 Token 失败');
        throw e;
      } finally {
        this.loadingToken = false;
      }
    },
    async joinAudienceChannel(channel) {
      if (!channel || !this.isSelectedRoomLive) return
      await this.initAudienceClient()
      if (!this.agoraClient) return

      this.previewLoading = true
      try {
        // 离开旧频道
        await this.leaveAgoraChannel()
        const tokenData = await this.fetchAudienceToken(channel)
        const token = tokenData.token || this.agora.token || null
        const uid = tokenData.joinUid != null ? tokenData.joinUid : tokenData.uid
        if (typeof uid !== 'number') {
          throw new Error('rtc uid must be numeric in uid mode')
        }
        const appId = tokenData.appId || this.agora.appId
        console.log(appId, channel, token, uid)
        await this.agoraClient.join(appId, channel, token, uid)
        for (const u of this.agoraClient.remoteUsers) {
          if (u.hasVideo) {
            await this.agoraClient.subscribe(u, 'video')
            if (u.videoTrack) {
              this.playRemoteVideoTrack(u)
              setTimeout(() => this.attachSnapshotTrack(u.videoTrack), 50)
            }
          }
          if (u.hasAudio) {
            await this.agoraClient.subscribe(u, 'audio')
            if (u.audioTrack && !this.videoPaused) {
              u.audioTrack.play()
            }
          }
        }
        this.remoteJoined = true
      } catch (err) {
        console.error('[LiveReply] join audience channel failed', err)
      } finally {
        this.previewLoading = false
      }
    },
    async renewAudienceToken() {
      const channel = this.videoSrc
      if (!channel || !this.agoraClient) return
      const tokenData = await this.fetchAudienceToken(channel)
      if (tokenData.token) {
        await this.agoraClient.renewToken(tokenData.token)
      }
    },

    async leaveAgoraChannel() {
      if (!this.agoraClient) return
      try {
        const remoteUsers = this.agoraClient.remoteUsers || []
        remoteUsers.forEach(user => {
          if (user.videoTrack) user.videoTrack.stop()
          if (user.audioTrack) user.audioTrack.stop()
        })
        await this.agoraClient.leave()
      } catch (err) {
        console.error('[LiveReply] leave audience channel failed', err)
      } finally {
        const container = this.$refs.agoraContainer
        if (container) {
          container.innerHTML = ''
        }
        this.remoteJoined = false
        this.activeRemoteUid = ''
        this.videoPaused = false
        this.previewLoading = false
      }
    },

    playRemoteVideoTrack(user) {
      if (!user || !user.videoTrack) return
      this.activeRemoteUid = String(user.uid)
      const container = this.$refs.agoraContainer
      if (!container) return
      let player = document.getElementById(`agora-player-${user.uid}`)
      if (!player) {
        player = document.createElement('div')
        player.id = `agora-player-${user.uid}`
        player.style.width = '100%'
        player.style.height = '100%'
        container.innerHTML = ''
        container.appendChild(player)
      }
      if (this.videoPaused) {
        try { user.videoTrack.stop() } catch (e) { }
        return
      }
      user.videoTrack.play(player)
    },

    pauseRemotePlayback() {
      const remoteUsers = this.agoraClient?.remoteUsers || []
      remoteUsers.forEach(user => {
        try { user.videoTrack?.stop?.() } catch (e) { }
        try { user.audioTrack?.stop?.() } catch (e) { }
      })
      this.videoPaused = true
    },

    resumeRemotePlayback() {
      this.videoPaused = false
      this.$nextTick(() => {
        const remoteUsers = this.agoraClient?.remoteUsers || []
        remoteUsers.forEach(user => {
          if (user.videoTrack) this.playRemoteVideoTrack(user)
          try { user.audioTrack?.play?.() } catch (e) { }
        })
      })
    },

    toggleVideoPlayback() {
      if (!this.activeRemoteUid) return
      if (this.videoPaused) {
        this.resumeRemotePlayback()
      } else {
        this.pauseRemotePlayback()
      }
    },

    async handleUserPublished(user, mediaType) {
      if (!this.agoraClient || !this.isSelectedRoomLive) return
      try {
        await this.agoraClient.subscribe(user, mediaType)

        if (mediaType === 'video' && user.videoTrack) {
          this.playRemoteVideoTrack(user)
          setTimeout(() => this.attachSnapshotTrack(user.videoTrack), 50)
        }
        if (mediaType === 'audio' && user.audioTrack) {
          if (!this.videoPaused) user.audioTrack.play()
        }
      } catch (err) {
        console.error('[LiveReply] subscribe remote user failed', err)
      }
    },

    handleUserUnpublished(user, mediaType) {
      if (mediaType === 'video') {
        const player = document.getElementById(`agora-player-${user.uid}`)
        if (player && player.parentNode) {
          player.parentNode.removeChild(player)
        }
        if (String(user.uid) === this.activeRemoteUid) {
          this.activeRemoteUid = ''
          this.videoPaused = false
        }
      }
    },
    async attachSnapshotTrack(agoraVideoTrack) {
      try {
        const el = this.$refs.snapshotVideo
        if (!el) {
          console.warn('[snapshot] no snapshotVideo ref')
          return
        }

        // ✅ 多版本兼容：优先官方方法，其次兜底字段
        const mst =
          (typeof agoraVideoTrack.getMediaStreamTrack === 'function' && agoraVideoTrack.getMediaStreamTrack()) ||
          agoraVideoTrack.mediaStreamTrack ||
          agoraVideoTrack._mediaStreamTrack

        console.log('[snapshot] mst:', mst)

        if (!mst) {
          console.warn('[snapshot] getMediaStreamTrack failed, track=', agoraVideoTrack)
          return
        }

        // clone
        const clone = mst.clone()
        this._snapshotMst?.stop?.()
        this._snapshotMst = clone

        const stream = new MediaStream([clone])
        el.srcObject = stream

        // ✅ 强制保证自动播放条件
        el.muted = true
        el.playsInline = true
        el.autoplay = true

        // ✅ 监听 metadata，确认 videoWidth 是否出来
        el.onloadedmetadata = () => {
          console.log('[snapshot] loadedmetadata', el.videoWidth, el.videoHeight)
        }
        el.onplaying = () => {
          console.log('[snapshot] playing', el.videoWidth, el.videoHeight)
        }

        const p = el.play()
        if (p && p.catch) await p.catch((err) => console.warn('[snapshot] play failed', err))
      } catch (e) {
        console.warn('[snapshot] attach failed', e)
      }
    },

    async handleReorder(newList) {
      if (!this.isSelectedRoomLive || this.goodsSaving) return
      const roomid = this.danmu_roomId || this.$store.state.currentRoom
      const roomSeq = this.$data._roomSelectSeq
      const previous = this.goods.slice()
      this.goodsSaving = true
      this.goods = newList.slice()
      // Invalidate an older list fetch before it can overwrite the draft.
      ++this.$data._goodsRequestSeq
      try {
        await reorderProducts({ stream_id: roomid, items: newList.map((item, index) => ({ id: item.id, display_order: index + 1 })) })
        if (roomSeq !== this.$data._roomSelectSeq) return
        this.$message && this.$message.success('商品顺序已保存，观看端约 1–2 秒更新')
        await this.fetchGoods(roomSeq, { showLoading: false })
      } catch (error) {
        if (roomSeq !== this.$data._roomSelectSeq) return
        this.goods = previous
        this.$message && this.$message.error(error.message || '排序保存失败，请重试')
      } finally {
        this.goodsSaving = false
      }
    },
    // 其他事件按业务处理…
    handleAdd() {
      if (!this.isSelectedRoomLive) {
        this.$message && this.$message.warning('历史直播商品列表只读')
      }
    },
    async fetchGoods(roomSelectSeq = this.$data._roomSelectSeq, { showLoading = this.isSelectedRoomLive } = {}) {
      const roomid = this.danmu_roomId || this.$store.state.currentRoom
      if (!roomid) {
        this.goods = []
        this.goodsLoading = false
        this.clearGoodsLoadingFallbackTimer()
        return
      }
      const goodsRequestSeq = ++this.$data._goodsRequestSeq
      this.clearGoodsLoadingFallbackTimer()
      this.goodsLoading = !!showLoading
      if (showLoading) {
        this.$data._goodsLoadingFallbackTimer = setTimeout(() => {
          if (roomSelectSeq === this.$data._roomSelectSeq && goodsRequestSeq === this.$data._goodsRequestSeq) {
            this.goodsLoading = false
          }
        }, GOODS_LOADING_FALLBACK_MS)
      }
      try {
        let { data: list } = await getProductList(roomid)
        if (roomSelectSeq !== this.$data._roomSelectSeq || goodsRequestSeq !== this.$data._goodsRequestSeq) return
        const all = list?.data || []
        for (let page = 2; page <= (list?.last_page || 1); page++) {
          const next = await getProductList(roomid, page)
          if (roomSelectSeq !== this.$data._roomSelectSeq || goodsRequestSeq !== this.$data._goodsRequestSeq) return
          all.push(...(next.data?.data || []))
        }
        this.goods = all
      } catch (err) {
        if (roomSelectSeq !== this.$data._roomSelectSeq || goodsRequestSeq !== this.$data._goodsRequestSeq) return
        console.error('[LiveReply] fetch goods failed', err)
        this.$message && this.$message.error('商品列表刷新失败，保留当前列表')
      } finally {
        if (roomSelectSeq === this.$data._roomSelectSeq && goodsRequestSeq === this.$data._goodsRequestSeq) {
          this.clearGoodsLoadingFallbackTimer()
          this.goodsLoading = false
        }
      }
    },
    handleSearch(kw) { },
    async handleToggleOnline(item) {
      if (!this.isSelectedRoomLive) {
        this.$message && this.$message.warning('历史直播商品列表只读')
        return
      }
      if (this.goodsRemoving) return
      try {
        await this.$confirm(`确定从当前直播间移除“${item.title || item.id}”吗？`, '移除商品', {
          confirmButtonText: '确认移除',
          cancelButtonText: '取消',
          type: 'warning',
        })
      } catch (error) {
        return
      }

      const roomSeq = this.$data._roomSelectSeq
      this.goodsRemoving = true
      this.goodsRemovalProgress = { current: 1, total: 1 }
      try {
        await deleteProduct(item.id, { suppressErrorNotification: true })
        if (roomSeq !== this.$data._roomSelectSeq) return
        this.goods = this.goods.filter(product => product.id !== item.id)
        this.$message && this.$message.success('商品已从购物车移除')
        await this.fetchGoods(roomSeq, { showLoading: false })
      } catch (error) {
        if (roomSeq === this.$data._roomSelectSeq) {
          this.$message && this.$message.error(error.message || '商品移除失败，请重试')
        }
      } finally {
        this.goodsRemoving = false
        this.goodsRemovalProgress = { current: 0, total: 0 }
      }
    },
    async handleBatchRemove(payload) {
      if (!this.isSelectedRoomLive) {
        this.$message && this.$message.warning('历史直播商品列表只读')
        return
      }
      if (this.goodsRemoving) return

      const requestedIds = Array.isArray(payload?.ids) ? payload.ids : []
      const availableIds = this.goods.map(item => item.id)
      const ids = requestedIds.filter((id, index, list) => (
        list.indexOf(id) === index && availableIds.indexOf(id) !== -1
      ))
      if (!ids.length) {
        this.$message && this.$message.warning('请先选择要移除的商品')
        return
      }

      try {
        await this.$confirm(
          `确定从当前直播间移除已选的 ${ids.length} 个商品吗？成功项会立即移除，失败项将保留勾选以便重试。`,
          '批量移除商品',
          {
            confirmButtonText: `移除 ${ids.length} 个`,
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
      } catch (error) {
        return
      }

      const roomSeq = this.$data._roomSelectSeq
      const succeededIds = []
      const failedIds = []
      this.goodsRemoving = true
      this.goodsRemovalProgress = { current: 0, total: ids.length }

      try {
        // The live backend currently exposes only POST /api/product/delete/{id},
        // so keep requests sequential and report a single aggregate result.
        for (let index = 0; index < ids.length; index++) {
          if (roomSeq !== this.$data._roomSelectSeq) {
            failedIds.push(...ids.slice(index))
            break
          }
          const id = ids[index]
          this.goodsRemovalProgress = { current: index + 1, total: ids.length }
          try {
            await deleteProduct(id, { suppressErrorNotification: true })
            succeededIds.push(id)
            this.goods = this.goods.filter(item => item.id !== id)
          } catch (error) {
            failedIds.push(id)
            console.error('[LiveReply] remove product failed', { id, error })
          }
        }

        if (roomSeq === this.$data._roomSelectSeq) {
          await this.fetchGoods(roomSeq, { showLoading: false })
          this.$nextTick(() => {
            this.$refs.goodsManager?.setSelectedIds(failedIds)
          })

          if (!failedIds.length) {
            this.$message && this.$message.success(`已移除 ${succeededIds.length} 个商品`)
          } else if (succeededIds.length) {
            this.$message && this.$message.warning(`批量移除完成：成功 ${succeededIds.length} 个，失败 ${failedIds.length} 个；失败项已保留勾选`)
          } else {
            this.$message && this.$message.error(`所选 ${failedIds.length} 个商品均移除失败，请稍后重试`)
          }
        }
      } finally {
        this.goodsRemoving = false
        this.goodsRemovalProgress = { current: 0, total: 0 }
      }
    },
    openStats(item) { },
    startExplain(item) {
      if (!this.isSelectedRoomLive || !this.$refs.danmu?.client) {
        this.$message && this.$message.warning('历史直播不支持讲解商品')
        return
      }
      this.$refs.danmu.client.send({
        type: 'event',
        event_type: 'LIVE_ROOM_STREAM_EVENT_TYPE_ADMIN_SENT_CUSTOMER_PRODUCT_URL',
        message: {
          url: item.image,
          // url:"https://shop.wokfoy.com/#/pages/product/product-detail?id=" + item.id,
          product_id: item.sedkill_product_id,
          sku_id: item.id
        },
        ts: Date.now(),
      })
    },
    handleSelectChange(ids) {
      this.selectedGoodsIds = Array.isArray(ids) ? ids.slice() : []
    },
    // 用户弹幕相关
    send_user_wa(e) {
      if (!this.isSelectedRoomLive || !this.$refs.danmu?.client) return
      this.$refs.danmu.client.send({
        type: 'event',
        event_type: 'LIVE_ROOM_STREAM_EVENT_TYPE_ADMIN_SENT_CUSTOMER_URL',
        message: e,
        ts: Date.now(),
      })
    },
    changeWa() {
      this.changeCustomerDialog = true
      this.wa_or_fb = 'WA'
    },
    changeFB() {
      this.changeCustomerDialog = true
      this.wa_or_fb = 'FB'
    },

    // =========================
    // 模拟用户发言（暖场）
    // =========================
    getWarmupAccounts() {
      return (this.warmup.accountsText || '')
        .split(/\r?\n/)
        .map(s => (s || '').trim())
        .filter(Boolean)
    },
    getWarmupMessages() {
      return (this.warmup.messagesText || '')
        .split(/\r?\n/)
        .map(s => (s || '').trim())
        .filter(Boolean)
    },
    pickRandom(arr) {
      if (!arr || arr.length === 0) return ''
      return arr[Math.floor(Math.random() * arr.length)]
    },
    refreshWarmupPreview() {
      this.warmup.previewAccount = this.pickRandom(this.getWarmupAccounts())
      this.warmup.previewMessage = this.pickRandom(this.getWarmupMessages())
    },
    handleWarmupToggle(val) {
      if (val) {
        this.startWarmup()
      } else {
        this.stopWarmup()
      }
    },
    startWarmup() {
      if (!this.canWarmupSend) {
        this.$message && this.$message.warning('请先选择直播间，并配置小号/话术库后再开启。')
        this.warmup.enabled = false
        return
      }
      if (this.warmup.running) return
      this.warmup.running = true
      this.refreshWarmupPreview()
      this.scheduleNextWarmup()
    },
    stopWarmup() {
      this.warmup.running = false
      this.warmup.enabled = false
      if (this.warmup.timer) {
        clearTimeout(this.warmup.timer)
        this.warmup.timer = null
      }
    },
    scheduleNextWarmup() {
      if (!this.warmup.running) return
      const min = Math.max(1, Number(this.warmup.intervalSecMin) || 1)
      const max = Math.max(min, Number(this.warmup.intervalSecMax) || min)
      const sec = Math.floor(min + Math.random() * (max - min + 1))
      if (this.warmup.timer) clearTimeout(this.warmup.timer)
      this.warmup.timer = setTimeout(() => {
        this.sendWarmupOnce(true)
      }, sec * 1000)
    },
    sendWarmupOnce(fromTimer = false) {
      if (!this.canWarmupSend) return
      const nickname = this.pickRandom(this.getWarmupAccounts())
      const content = this.pickRandom(this.getWarmupMessages())
      if (!nickname || !content) return

      // 发送给 Danmaku WS，让后端/弹幕系统广播
      try {
        this.$refs.danmu.client.send({
          type: 'message',
          event_type: this.warmup.eventType || 'LIVE_ROOM_STREAM_EVENT_TYPE_USER_SEND_MESSAGE',
          client_type: 't',
          nickname: nickname,
          message: content,
          ts: Date.now(),
        })
        this.warmup.previewAccount = nickname
        this.warmup.previewMessage = content
      } catch (e) {
        console.error('[Warmup] send failed', e)
        this.$message && this.$message.error('发送失败：请检查弹幕连接是否正常。')
        if (fromTimer) {
          // 定时触发失败时自动停止，避免无限报错
          this.stopWarmup()
        }
        return
      }

      if (this.warmup.running) this.scheduleNextWarmup()
    }
  }
}
</script>
<style scoped>
body {
  /* background: radial-gradient(circle at top left, rgba(29, 78, 216, 0.16), transparent 40%),
    linear-gradient(140deg, #050b1a, #081126 55%, #040713 100%); */
}

.bigscreen {
  padding: 12px;
  /* background: radial-gradient(circle at top left, rgba(29, 78, 216, 0.16), transparent 40%),
    linear-gradient(140deg, #050b1a, #081126 55%, #040713 100%); */
  height: calc(100svh - 250px);
  min-height: 560px;
  color: #e5eaf3;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.toolbar {
  margin-bottom: 12px;
  background: rgba(10, 18, 32, 0.9);
  border: 1px solid #14203a;
}

.toolbar ::v-deep .el-form-item__label {
  color: #9fb4d3;
}

.room-toolbar {
  margin-bottom: 12px;
  background: rgba(10, 18, 32, 0.92);
  border: 1px solid #14203a;
}

.room-toolbar ::v-deep .el-card__body {
  padding: 12px 16px 4px;
}

.room-toolbar ::v-deep .el-form-item__label {
  color: #9fb4d3;
}

.room-select {
  width: 320px;
}

.room-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.room-option-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.room-option-meta {
  flex: none;
  color: #909399;
  font-size: 12px;
}

.error-alert {
  margin-bottom: 12px;
  background: rgba(255, 153, 0, 0.12);
  border: 1px solid rgba(255, 153, 0, 0.32);
  color: #ffcf8f;
}

.full {
  display: flex;
  /* background: radial-gradient(circle at top left, rgba(29, 78, 216, 0.16), transparent 40%),
    linear-gradient(140deg, #050b1a, #081126 55%, #040713 100%); */
  flex: 1;
  min-height: 0;
}

.left {
  flex-basis: 480px;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.middle {
  flex-basis: 480px;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.right {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

/* .right ::v-deep .el-row {
  margin-top: 20px;
} */

::-webkit-scrollbar {
  display: none;
}

.panel {
  background: rgba(10, 18, 32, 0.92);
  border: 1px solid #14203a;
  color: #e5eaf3;
  height: 100%;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.panel ::v-deep .el-card__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.middle .panel ::v-deep .el-card__body {
  padding: 0;
}

.video-panel ::v-deep .el-card__body {
  display: flex;
  align-items: center;
  justify-content: center;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-title {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.panel-substats {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #98a9c9;
}

.panel-substats strong {
  color: #53c3ff;
  margin-left: 6px;
}

.kpi-row {
  margin-bottom: 12px;
}

.kpi-card {
  position: relative;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(160deg, rgba(14, 53, 118, 0.5), rgba(9, 19, 42, 0.8));
  border: 1px solid rgba(64, 158, 255, 0.18);
}

.kpi-label {
  font-size: 13px;
  opacity: 0.78;
}

.kpi-value {
  font-size: 26px;
  font-weight: 700;
  margin-top: 6px;
}

.kpi-delta {
  position: absolute;
  top: 10px;
  right: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.08);
}

.kpi-delta.up {
  color: #67c23a;
}

.kpi-delta.down {
  color: #f56c6c;
}

.chart-card,
.table-card {
  flex: none;
}

.chart-grid {
  margin-bottom: 12px;
}

/* 原来的样式保持不动，只改了 video 区块相关 */

.video-wrap {
  position: relative;
  width: min(390px, 100%);
  height: min(844px, 100%);
  aspect-ratio: 390 / 844;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
}

.video-panel .agora-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
}

.video-wrap.is-history .agora-container {
  background: linear-gradient(180deg, #101827, #020617);
}

.agora-placeholder {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.78);
  font-size: 15px;
  pointer-events: none;
}

.history-placeholder {
  z-index: 4;
  background: rgba(2, 6, 23, 0.72);
}

.preview-loading {
  gap: 8px;
  color: #bfdbfe;
  background: rgba(2, 6, 23, 0.38);
}

.preview-loading .el-icon-loading {
  font-size: 18px;
}

.video-toggle-btn {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 18px;
  border: 0;
  border-radius: 22px;
  color: #fff;
  background: rgba(15, 23, 42, 0.78);
  cursor: pointer;
  backdrop-filter: blur(6px);
  font-size: 18px;
}

.video-toggle-btn i {
  font-size: 18px;
}

.video-toggle-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.video-paused-mask {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  background: rgba(0, 0, 0, 0.48);
  pointer-events: none;
}

.danmaku-panel .danmaku-wrap {
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.danmaku-panel ::v-deep .msg {
  font-size: 18px;
}

.danmaku-empty {
  height: 90svh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7a8ab0;
  font-size: 14px;
}

.right .panel:last-child {
  margin-bottom: 0;
}

.right > .el-row {
  flex: 1;
  min-height: 0;
  display: flex;
}

.el-table {
  background: transparent;
}

.el-table::before {
  background: transparent;
}

.el-table th,
.el-table td {
  background: transparent;
  color: #e5eaf3;
}

.el-table th {
  color: #9fb4d3;
}

.right-tabs {
  flex: 1;
  min-height: 0;
  margin-top: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.right-tabs ::v-deep .el-tabs__content {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.right-tabs ::v-deep .el-tab-pane {
  height: 100%;
  min-height: 0;
}

.warmup-wrap {
  padding: 6px 4px;
}

.warmup-tip {
  margin-bottom: 10px;
}

.warmup-hint {
  color: #888;
  font-size: 12px;
  margin-top: 4px;
}

.warmup-status {
  margin-left: 10px;
  font-size: 12px;
  color: #999;
}

.warmup-status.on {
  color: #13ce66;
}

.preview-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.preview-sep {
  margin: 0 6px;
  color: #666;
}

.preview-msg {
  color: #333;
}

.warmup-inner-tabs {
  margin-top: 4px;
}

.warmup-task-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.warmup-task-wrap {
  padding: 8px;
}
</style>
